import FingerprintJS from '@fingerprintjs/fingerprintjs';
import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
    removeSignature
} from '../../services/AuthService';

const fpPromise = FingerprintJS.load();

export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';  
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';
export const UPDATE_TOKEN = '[update token] update token';
export const NAVTOGGLE = 'NAVTOGGLE';



export function signupAction(email, password, navigate) {
	
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000,
                //history,
            );
            dispatch(confirmedSignupAction(response.data));
            navigate('/dashboard');
			//history.push('/dashboard');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

// export function Logout(navigate) {
// 	localStorage.removeItem('userDetails');
//     localStorage.removeItem('fcmTokenSaved');
//     navigate('/login');
    
// 	return {
//         type: LOGOUT_ACTION,
//     };
// }

export function Logout(navigate) {
    return async (dispatch) => {
        try {
            // Only call removeSignature if userDetails exists
            if (localStorage.getItem('userDetails')) {
                const fp = await fpPromise;
                const result = await fp.get();
                const visitorId = result.visitorId;
                await removeSignature(visitorId);
            }
        } catch (err) {
            console.warn('Failed to remove device signature:', err.message || err);
            // Even if the API fails, we proceed with logout
        }

        // Clear localStorage after API call
        localStorage.removeItem('userDetails');
        localStorage.removeItem('fcmTokenSaved');

        // Dispatch logout action (clears Redux auth state)
        dispatch({ type: LOGOUT_ACTION });

        // Redirect to login
        navigate('/login');
    };
}

export function loginAction(email, password, navigate) {
    return (dispatch) => {
         login(email, password)
            .then((response) => { 
                saveTokenInLocalStorage(response.data.data);
                // runLogoutTimer(
                //     dispatch,
                //     response.data.expiresIn * 1000,
                //     navigate,
                // );
               dispatch(loginConfirmedAction(response.data.data));		              
			   navigate('/dashboard');                
            })
            .catch((error) => {		
                // console.log(error.response)		
                const errorMessage = formatError(error.response.data);
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
export const navtoggle = () => {    
    return {        
      type: 'NAVTOGGLE',
    };
};